import {
  ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION,
  ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS,
  ACT_INSTANCES_SET_SELECTED_ELEMENT,
} from '../../constants/actions';

export const fetchElementsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION,
});

export const fetchElementsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_ELEMENTS_SUCCESS_ACTION,
  payload: data,
});

export const getElementInitAction = () => ({
  type: ACT_INSTANCES_GET_ELEMENT_INIT_ACTION,
});

export const getElementSuccessAction = data => ({
  type: ACT_INSTANCES_GET_ELEMENT_SUCCESS_ACTION,
  payload: data,
});

export const addElementInitAction = data => ({
  type: ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION,
  payload: data,
});

export const addElementSuccessAction = data => ({
  type: ACT_INSTANCES_ADD_ELEMENT_SUCCESS_ACTION,
  payload: data,
});

export const deleteElementInitAction = id => ({
  type: ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION,
  payload: id,
});

export const deleteElementSuccessAction = () => ({
  type: ACT_INSTANCES_DELETE_ELEMENT_SUCCESS_ACTION,
});

export const updateElementFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS,
  payload: filters,
});

export const updateSelectedElementAction = element => ({
  type: ACT_INSTANCES_SET_SELECTED_ELEMENT,
  payload: element,
});
